export default {
	app: 'e-Boleta',
	sii: 'Servicio de Impuestos Internos',
	pagina404: 'Esta página no existe',
	login:{
		iniciarSesion: 'Iniciar Sesión',
		nombreUsuario: 'Nombre de Usuario',
		clave: 'Contraseña',
		info:{
			funcion:'Emite boletas electrónicas demanera rápida y sencilla.',
			internet:'Envíalas por email a tus clientes.',
			seguridad:'Todo sin descuidar tu seguridad o la de tu negocio.'
		},
		rules:{
			requerido: 'Este campo es requerido',
			minimo: 'Debe tener al menos {min} caracteres'
		},
		providers:{
			claveUnica: 'Clave Única',
			claveTributaria: 'Clave Tributaria'
			,lista: 'También puedes iniciar sesión con estas opciones:'
		}
	},
	controlVersion:{
		estados:{
			dafault:'Estimado contribuyente, la versión de eBoleta que está utilizando ha dejado de ser soportada. Por favor actualice su aplicación.'
			,COD_NO_RELEASE: 'Estimado contribuyente, esta versión de la aplicación aún no ha sido liberada. Por favor espere a la publicación oficial de esta versión. <BR/>Si este error persiste, por favor diríjase a <strong><a href=https://www.sii.cl/ayudas/>nuestra página de ayuda</a></strong> o contáctenos a los números <strong>22 395 1115</strong> y <strong>22 395 1000</strong>.'
			,COD_EOL: 'Estimado contribuyente, esta versión de la aplicación ya no es soportada. Le recomendamos actualizarla para poder utilizarla.'
			,COD_OUTDATED: `Estimado contribuyente, existe una nueva versión de la aplicación, por lo cual recomendamos que la descargue y así asegure su correcto funcionamiento.<br/>Próximamente se impedirá el uso de su versión actual.`
		}
	},
	$vuetify: {
	},
	claveUnica:{
		inicioSesionCaption: 'Para iniciar sesión con tu Clave Única, haz clic aquí'
	}
}